import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import vuecookie from 'vue-cookies'
import BootstrapVue from 'bootstrap-vue'
import JQuery from 'jquery'
import {i18n} from '@/plugins/i18n'

import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'
import InfiniteLoading from 'vue-infinite-loading'
import vueNumeralFilterInstaller from 'vue-numeral-filter'
import ErrorService from "./helpers/ErrorService";

//import 'bootstrap/dist/css/bootstrap.css'
//import 'bootstrap-vue/dist/bootstrap-vue.css'
/*
* usage example: <fontAwesomeIcon :icon="['fas', 'file-upload']" size="2x" />
* nothing needs to be imported in the components, already usable as shown above
*/
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { ToggleButton } from 'vue-js-toggle-button'
import Multiselect from 'vue-multiselect'

require('./assets/sass/main.scss')

import asDate from "./filters/asDate";
import asNumber from "./filters/asNumber";
import asThousand from "./filters/asThousand";

library.add(fas)
library.add(far)
library.add(fab)

// register globally
Vue.component('multiselect', Multiselect)
Vue.component('fontAwesomeIcon', FontAwesomeIcon)
Vue.component('ToggleButton', ToggleButton)

window.$ = window.jQuery = JQuery
Vue.use(BootstrapVue)
Vue.use(vuecookie)
Vue.use(InfiniteLoading)
Vue.use(vueNumeralFilterInstaller, { locale: 'en-gb' })

Vue.use(Chartkick.use(Chart))
Chartkick.options = {
  library: {animation: {easing: 'easeOutQuart'}},
}

Vue.config.productionTip = false
Vue.prototype.$axios = axios
// Handle all Vue errors in case we are already not catching them.
ErrorService.initHandler();
Vue.config.errorHandler = (error) => ErrorService.onError(error);
// #EIPP-561 this is for component specific error logging. if there is a case when you want to throw the errors of your own.
// above will fail break your component. So , use this.$logError function in the catch to be able to log error
// without importing the ErrorService.
Vue.prototype.$logError = (error) => ErrorService.onError(error);

// interceptor is run with every request before every catch() and then()
// if user session token is expired then user will be logged out and redirected to login page
// this interceptor works only on error requests, normal response is not modified in any way
axios.interceptors.response.use( function (response) {
  return response
}, function (error) {
    if(error.response) {
      if(error.response.data) {
        if(error.response.data.error) {
          if(error.response.data.error.status == 401 && error.response.data.error.statusText == 'User token expired') {
            // dispatch action to log user out and handle all the data reset
            store.dispatch('handleTokenExpiration')
          }
        } else {
          // handle all the error responses ( the ones who would go to .catch() ) so there is no need to 
          // dispatch this action in every function
          store.dispatch('handleResponse', error.response)
        }
      } else {
        console.log('Interceptor error')
        console.log(error.response.data)
      }
    } else {
      // handle all the error responses ( the ones who would go to .catch() ) so there is no need to
      // dispatch this action in every function
      store.dispatch('handleResponse', error.response)
      console.log('Interceptor error')
      console.log(error.response)
    }

    ErrorService.onError(error);
    // return error with promise to make sure vue functions will read the incoming
    // response as an error and not a successful response
    return Promise.reject(error.response)
});

// make translation function globally available to all functions
Vue.mixin({
  methods: {
    t(str, fallbackStr) {
      // $t returns translation, $te checks if the translation exists and returns true/false
      // if there is no translation and translation for default language (EN) doesnt exist then return the 2nd parameter as default translation
      // str => message key used to find the translation
      // change commented returns and fallback locale in i18n.js to make the function return just the key as message shown in case the translation doesnt exist
      if (this.$t && this.$te) {
        if(this.$t(str) != fallbackStr && this.$t(str) != '' && str != this.$t(str)) {
          return this.$t(str)
        }
        if (this.$te(str)) {
          return this.$t(str)
        } else {
          //return this.$t(str)
          return fallbackStr
        }
      } else {
        if (fallbackStr) {
          //return this.$t(str)
          return fallbackStr
        } else {
          return str
        }
      }
    }
  }
})

Vue.filter("asDate", asDate);
Vue.filter("asNumber", asNumber);
Vue.filter("asThousand", asThousand);

//vue instance
export default new Vue({
  router,
  store,
  vuecookie,
  i18n,
  beforeCreate() {
    //get the site configuration
    store.dispatch('getTemplateDetails').then(response => {
      if(response) {
        document.title = 'EIPP : ' + response
      } else {
        const portalUrl = window.location.host
        const parts = portalUrl.split('.')
        if(parts[0]) {
          const name = parts[0]
          if(name[0]) {
            document.title = "EIPP : " + name[0].toUpperCase() + name.slice(1)
          } else {
            document.title = 'EIPP : ' + name
          }

        } else {
          document.title = 'Netsend V3 Portal'
        }
      }
    })
  },
  render: h => h(App)
}).$mount('#app')
